const $ = require('jquery');

const selectChange = function() {
	const $countrySelects = document.querySelectorAll('.js-select-country');
	if ($countrySelects.length === 0) {
		return;
	}

	// Called inside the change event, since the element and its data might be replaced through coupon AJAX calls
	const getFoundData = value => {
		const $data = document.querySelector('[data-shipment-per-country]');
		if (!$data) {
			return false;
		}

		const collection = JSON.parse($data.getAttribute('data-shipment-per-country'));

		return collection.find(obj => obj.Code === value);
	};

	// Turns string to float while removing any euro signs
	const stringToFloat = str => parseFloat(str.replace(',', '.').replace('€', ''));
	// Turn float to string
	const floatToString = flt => flt.toFixed(2).replace('.', ',');

	// eslint-disable-next-line prefer-arrow-callback
	$('#land').on('change', function(e) {
		const found = getFoundData(e.target.value);
		if (!found) {
			return;
		}

		// QuerySelectors inside the change event, since some elements might be replaced through coupon AJAX calls
		const $price = document.querySelector('.js-price'); // To place the new price excluding shipping costs in
		const $sum = document.querySelector('.js-sum'); // To get the current sum from
		const $freeshipment = document.querySelector('.js-freeshipment'); // To place the new shipping costs text in
		const $total = document.querySelector('.js-total'); // To place the new total price in
		const $minus = document.querySelectorAll('.js-minus'); // To get all costs that need to be subtracted from the total price

		let minus = 0;
		for (let i = 0; i < $minus.length; i += 1) {
			minus += stringToFloat($minus[i].innerText);
		}
		
		const shipment = found.Shipment;
		const free = found.Free;
		const threshold = found.Threshold;

		const sum = stringToFloat($sum.innerText);
		const shippingprice = stringToFloat(shipment); // 'shipment', but as float for calculations
		const totalprice = parseFloat(sum - minus);
		const totalpriceWithShipping = parseFloat(sum + shippingprice - minus);
		const freeshipment = stringToFloat(threshold); // 'free', but as float for calculations
		const toGo = floatToString(parseFloat(freeshipment - totalprice));
		
		if ($freeshipment) {
			if (stringToFloat(toGo) <= 0 && free == "True") {
				$price.innerHTML = `&euro; ${0}`;
				$total.innerHTML = `&euro; ${floatToString(totalprice)}`;
				$freeshipment.innerHTML = '';
			} else {
				$price.innerHTML = `&euro; ${shipment}`;
				$total.innerHTML = `&euro; ${floatToString(totalpriceWithShipping)}`;
				$freeshipment.innerHTML = '';
			}
		}
		else{
			$price.innerHTML = `&euro; ${shipment}`;
			$total.innerHTML = `&euro; ${floatToString(totalpriceWithShipping)}`;
		}
	});

	// eslint-disable-next-line prefer-arrow-callback
	$countrySelects.forEach(function($el) {
		const $target = $el.dataset.target;

		// eslint-disable-next-line prefer-arrow-callback
		$($el).on('change', function(e) {
			const found = getFoundData(e.target.value);
			if (!found) {
				return;
			}

			// QuerySelectors inside the change event, since some elements might be replaced through coupon AJAX calls
			if (found.Code !== 'NL') {
				$(`#${$target}`).removeClass('is-hidden');
			} else {
				$(`#${$target}`).addClass('is-hidden');
			}
		});
	});
};

module.exports = selectChange;
